import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/api/query-keys";
import { getConversations, type ListConversationsParams } from "../api/getConversations";

/** Conversation list for the sidebar. Key comes from the central factory. */
export function useConversations(params: ListConversationsParams = {}) {
  return useQuery({
    queryKey: queryKeys.conversations.list({ search: params.search }),
    queryFn: () => getConversations(params),
  });
}
